"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fiCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var fiCountry = exports.fiCountry = function fiCountry(t) {
  return {
    id: 'FI',
    name: t('Finland'),
    flag: '🇫🇮',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{5}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 00100 or 40000',
    phonePrefix: '358',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Helsinki',
    currency: 'EUR'
  };
};